import { getQueryParams } from '@office-start/url-parser-utility';
export function resolveTeachingUiConfig(componentContext, featureGates) {
    var isMockMode = getIsMockMode(componentContext, featureGates);
    var queryParams = getQueryParams(location.search);
    var teachingUiConfig = {
        hideInTestMode: getHideInTestMode(componentContext, queryParams),
        tuiFlowInTestMode: getTuiFlowInTestMode(isMockMode, queryParams),
        tuiTestSequences: getTuiTestSequences(isMockMode, queryParams),
        version: 3,
    };
    return teachingUiConfig;
}
function getIsMockMode(componentContext, featureGates) {
    var _a;
    var inMockMode = componentContext.inMockMode;
    var overridesEnabled = ((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.teachingUiGates) === null || _a === void 0 ? void 0 : _a.teachingUiOverridesEnabled) || false;
    var isMockMode = inMockMode || overridesEnabled;
    return isMockMode;
}
function getHideInTestMode(componentContext, queryParams) {
    return componentContext.inMockMode && queryParams['showfirstrun'] !== '1';
}
function getTuiFlowInTestMode(isMockMode, queryParams) {
    if (isMockMode) {
        var queryParam = queryParams['tuiFlow'];
        if (['1', '2', '3', '4', '5'].includes(queryParam)) {
            return queryParam;
        }
    }
    return '0';
}
function getTuiTestSequences(isMockMode, queryParams) {
    if (isMockMode) {
        var queryParam = queryParams['tuioverrides'];
        if (queryParam) {
            return queryParam.split(',');
        }
    }
    return [];
}
//# sourceMappingURL=resolveTeachingUiConfig.js.map